export class Lazy<TValue> {
	public static create<TValue>(factory: () => TValue): Lazy<TValue> {
		return new Lazy(factory);
	}

	private value: undefined | { current: TValue };

	private constructor(private readonly factory: () => TValue) {}

	public get(): TValue {
		if (this.value == null) {
			this.value = { current: this.factory() };
		}

		return this.value.current;
	}

	public tap(fn: (value: TValue) => void): void {
		if (this.value != null) {
			fn(this.value.current);
		}
	}
}
